import React, {useEffect, useMemo, useState} from "react";
import {connect} from "react-redux";

import {showPricingPopup} from "../pricingActions";
import PricingCheckbox from "../PricingComponents/PricingCheckbox";
import PricingPopupContext, {usePricingPopupContext} from "./PricingPopupContext";
import {toggleArrayValue} from "../../FeatureCreator/FeaturesFilters/filtersFunctions";

const PricingPopupFeatureGroups = (props) => {

  const {featureGroupsLoading, featureGroups, pricingPopupOpened} = props;
  const {pricingPopupState, pricingPopupDispatch} = usePricingPopupContext(PricingPopupContext);
  const {featureGroupsChecked} = pricingPopupState;

  const [searchInputValue, setSearchInputValue] = useState("");

  useEffect(() => {
    if (!pricingPopupOpened && searchInputValue) {
      setSearchInputValue("");
    }
  }, [pricingPopupOpened]);

  const displayFeatureGroups = useMemo(() => {
    if (featureGroupsLoading) {
      return []
    }
    if (searchInputValue) {
      const lowerCasedText = searchInputValue.toLowerCase();
      return featureGroups.filter(featureGroup => {
        return (featureGroup.customDisplayName || featureGroup.groupName || "").toLowerCase().includes(lowerCasedText)
      })
    }
    return featureGroups
  }, [featureGroupsLoading, searchInputValue, featureGroups]);

  if (featureGroupsLoading) {
    return (
      <div className="pr-popup__content scrollbar3 mt-125 mb-125 pr-1 flex-item relative">
        <div className="ui-loader ui-loader--medium absolute"/>
      </div>
    )
  }

  const allChecked = displayFeatureGroups.every(featureGroup => {
    return featureGroupsChecked.includes(featureGroup.groupName)
  });

  return (
    <div className="pr-popup__content scrollbar3 mt-125 mb-125 pr-1 flex-item">
      <input className="generic-popup-textbox radius-5 mb-05"
             type="search"
             placeholder="Search"
             onChange={(event) => setSearchInputValue(event.target.value)}
             value={searchInputValue}/>
      <div className="grid pr-grid pr-grid--light pr-grid--featureGroups">
        <div className="pr-grid-th font--12">
          <div className="pr-grid-cell flex flex--center pl-1 pr-1 h-2">
            <PricingCheckbox id={"toggle--all"}
                             text={""}
                             className="pr-checkbox--white min-h-125 flex flex--center flex--start"
                             checked={allChecked}
                             onChange={() => pricingPopupDispatch({
                               featureGroupsChecked: allChecked
                                 ? featureGroupsChecked.filter(groupName => {
                                   return !displayFeatureGroups.some(fg => fg.groupName === groupName)
                                 })
                                 : [...featureGroupsChecked, ...displayFeatureGroups.filter(fg => {
                                   return !featureGroupsChecked.includes(fg.groupName)
                                 }).map(fg => fg.groupName)]
                             })}/>
          </div>
          <div className="pr-grid-cell flex flex--center pl-1 pr-1 h-2 color-black3">Group Name</div>
          <div className="pr-grid-cell flex flex--center pl-1 pr-1 h-2 color-black3">Description</div>
          <div className="pr-grid-cell flex flex--center h-2 color-black3">Items</div>
        </div>
        {displayFeatureGroups.map(featureGroup => {
          const key = featureGroup.groupName;
          return (
            <div className="pr-grid-row mb-1" key={key}>
              <div className="pr-grid-cell font--12 color-green bold flex flex--center flex--start pl-1 pr-1">
                <PricingCheckbox id={key}
                                 text={""}
                                 className="pr-checkbox--white min-h-125 flex flex--center flex--start"
                                 checked={featureGroupsChecked.includes(key)}
                                 onChange={() => pricingPopupDispatch({
                                   featureGroupsChecked: [...toggleArrayValue(featureGroupsChecked, key)]
                                 })}/>
              </div>
              <div className="pr-grid-cell font--12 flex flex--center pl-1 pr-1 text-left flex--start">
                <span className="secondary">{featureGroup.customDisplayName || featureGroup.groupName}</span>
              </div>
              <div className="pr-grid-cell flex flex--center flex--between pl-1 pr-1 text-left flex--start">
                <p className="font--12 color-textgray margin-0 pr-three-lines">{featureGroup.description}</p>
              </div>
              <div className="pr-grid-cell flex flex--center flex--between pl-1 pr-1"></div>
            </div>
          )
        })}
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {loading, featuresGroups} = store.projectScopeNew;
  const {pricingPopupOpened} = store.popups;

  return {
    featureGroupsLoading: loading,
    featureGroups: featuresGroups,
    pricingPopupOpened,
  };
};

const mapDispatchToProps = {
  showPricingPopup
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(PricingPopupFeatureGroups)
)
